import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="forgot-form">
        <img src="/logo_wide.webp" alt="RED EYE" className="w-36 mx-auto mb-8" />
        <h1 className="font-heading font-black uppercase text-2xl text-[#F0EDEA] text-center mb-6">Reset Password</h1>
        {sent ? (
          <div className="text-[#F0EDEA] text-sm text-center bg-[#1C1C1C] border border-[#333] rounded-xl p-5" data-testid="forgot-sent">
            If an account exists for that email, a reset link has been sent.
          </div>
        ) : (
          <>
            {error && <div className="text-[#FF4550] text-sm mb-4">{error}</div>}
            <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="Email" className="w-full bg-[#1C1C1C] border border-[#333] rounded-xl h-12 px-4 text-[#F0EDEA] focus:border-[#E60000] outline-none mb-6" />
            <button type="submit" className="btn-skew btn-primary w-full"><span>Send Reset Link</span></button>
          </>
        )}
        <Link to="/admin/login" className="block text-center text-[#A8A2A0] text-sm mt-4 hover:text-[#E60000]">Back to login</Link>
      </form>
    </div>
  );
}
